import React from "react"
import Layout from "../components/layout"
import { Link, graphql } from "gatsby"
import parse from 'html-react-parser';
import { scrollDiv, scrollToGroup } from '../Helpers'

import Seo from "../components/seo"
import Hero from "../components/Hero"
import IconArrowShortOrange from "../components/icons/IconArrowShortOrange"
import IconDropFilled from "../components/icons/IconDropFilled"
import IconPollen from "../components/icons/IconPollen"
import IconTransparency from "../components/icons/IconTransparency"
import IconPermeability from "../components/icons/IconPermeability"
import IconPriceWarranty from "../components/icons/IconPriceWarranty"
import IconTruck from "../components/icons/IconTruck"

import PriceCalculatorBanner from "../components/PriceCalculatorBanner"
import BlockAdvantages from "../components/BlockAdvantages"
import BlockLastProjects from "../components/BlockLastProjects"
import BlockAdvices from "../components/BlockAdvices"
import BlockFAQ from "../components/BlockFAQ"

import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation, Pagination } from "swiper";


export default function ProductCategory({ data }) {

    const page = data.wpPage
    const acf = page.pollenschutzArchACF

    let metaTitle = false
    let metaDescription = false
    let ogImage = false

    if (page.seoMetaData) {
        metaTitle = page.seoMetaData.seoMetaTitle ? page.seoMetaData.seoMetaTitle : false
        metaDescription = page.seoMetaData.seoMetaDescription ? page.seoMetaData.seoMetaDescription : false
        ogImage = page.seoMetaData.seoMetaOgImage ? page.seoMetaData.seoMetaOgImage : false
    }

    var title_nop = acf.prodCategoryHerotitle.replace("<p>", "")
    var title = title_nop.replace("</p>", "")

    const groups = acf.pollenschutzGroups
    const totalGroups = groups.length

    var totalProducts = 0
    var groupsList = []
    groups && groups.map((group, index) => {
        totalProducts = totalProducts + group.groupProducts.length
        groupsList[index] = group.groupTitle
    })

    var arrows_classes = 'absolute top-6 lg:top-7 w-full flex justify-between pb-12 '
    var scrollableCategory = 'w-full scroll-smooth pb-12 '
    if (totalProducts <= 2) {
        arrows_classes += 'hidden'
    } else if (totalProducts === 3) {
        arrows_classes += 'lg:hidden'
        scrollableCategory += 'overflow-x-auto whitespace-nowrap lg:overflow-x-visible lg:whitespace-normal'
    } else if (totalProducts === 4) {
        arrows_classes += 'xl:hidden'
        scrollableCategory += 'overflow-x-auto whitespace-nowrap xl:overflow-x-visible xl:whitespace-normal'
    } else if (totalProducts > 4) {
        scrollableCategory += 'overflow-x-auto whitespace-nowrap'
    }

    return (
        <Layout>
            <Seo
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                uri={page.uri}
                ogImage={ogImage}
            />
            <Hero
                img={acf.prodCategoryCover.srcSet}
                h1="true"
                title={title}
                text="false"
            />
            <section className="container mx-auto px-1 pt-16 lg:pt-36 product-category">
                <span className="uppercase block mb-12 text-lg">{acf.prodCategoryListSubtitle}</span>
                <h2 className="pl-6 lg:px-24 text-3xl lg:text-5xl m-0">{acf.prodCategoryListTitle}</h2>
                <div className="relative my-6 lg:my-12">
                    {totalProducts > 2 &&
                        <div className={arrows_classes}>
                            <button className="rounded-full bg-rekord-orange h-9 w-9 flex items-center justify-center -ml-0.5 z-20" onClick={() => { scrollDiv('prodCategory', 'left', totalProducts) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" viewBox="0 0 32.621 24.543">
                                    <g id="Pfeil" transform="translate(32.621)">
                                        <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H-29.378" transform="translate(0 11.771)" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="3" />
                                        <path id="Fill_12" data-name="Fill 12" d="M-2.047,24.543,0,22.344-10.838,12.273,0,2.2-2.047,0l-13.2,12.273Z" fill="#fff" transform="translate(-17.378)" />
                                    </g>
                                </svg>
                            </button>
                            <button className="rounded-full bg-rekord-orange h-9 w-9 flex items-center justify-center -mr-0.5 z-20" onClick={() => { scrollDiv('prodCategory', 'right', totalProducts) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="19" viewBox="0 0 32.621 24.543">
                                    <g id="Pfeil" transform="translate(0)">
                                        <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H29.378" transform="translate(0 11.771)" fill="none" stroke="#fff" strokeMiterlimit="10" strokeWidth="3" />
                                        <path fill="#fff" data-name="Fill 12" d="M2.047,24.543,0,22.344,10.838,12.273,0,2.2,2.047,0l13.2,12.273Z" transform="translate(17.378)" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                    }
                    <div id="prodCategory" className={scrollableCategory}>
                        {groups && groups.map((group, index) => {
                            const products = group.groupProducts
                            return (
                                <>
                                    {products && products.map((prod, index) => {
                                        const prodACF = prod.pollenschutzACF
                                        var classes = 'product-category-single w-product-1/2 lg:w-product-1/3 xl:w-product-1/4 h-full inline-grid flex-col justify-start text-center rounded-xl shadow-lg mx-1 lg:mx-2 xl:mx-4 whitespace-normal'
                                        return (
                                            <div className={classes}>
                                                <div className="bg-rekord-lgray rounded-t-xl px-2 py-4 z-10">
                                                    <div className="text-sm font-light min-h-12">{group.groupTitle}</div>
                                                    <a href="#ausfuehrungen" title={prod.title} className="text-black no-underline">
                                                        <h3 className="text-xl lg:text-3xl mb-0">{prod.title}</h3>
                                                    </a>
                                                </div>
                                                <div className="p-2">
                                                    <a href="#ausfuehrungen" title={prod.title} className="text-black no-underline">
                                                        {prodACF.prodLineImage ? <img className="my-4 mx-auto max-h-32 md:max-h-96" srcSet={prodACF.prodLineImage.srcSet} alt={prod.title} sizes="(max-width: 500px) 100vw, 500px" /> : ''}
                                                    </a>
                                                    <div className="product-category-single-description min-h-40 md:min-h-32">{parse(prodACF.prodLineShortDescription)}</div>
                                                    <a href="#ausfuehrungen" title={prod.title} className="text-lg text-rekord-orange font-semibold mb-8">
                                                        <span className="inline-block">Nähere Infos</span><IconArrowShortOrange w="60" h="60" direction="right" />
                                                    </a>
                                                    {prodACF.prodLinePricecat && prodACF.prodLinePricecat !== '' ?
                                                        <div className="text-lg mb-8">
                                                            <h4>Preisklasse</h4>
                                                            {Array.from({ length: prodACF.prodLinePricecat }, () => ('€'))}
                                                        </div>
                                                        : ''}
                                                    {prodACF.prodLinePollen && prodACF.prodLinePollen !== '' ?
                                                        <div className="flex flex-col items-center mb-8">
                                                            <IconPollen w="45" h="45" />
                                                            <h4>Pollenreduktion</h4>
                                                            <p>{parse(prodACF.prodLinePollen)}</p>
                                                        </div>
                                                        : ''}
                                                    {prodACF.prodLineDeliverytime && prodACF.prodLineDeliverytime !== '' ?
                                                        <div className="flex flex-col items-center mb-8">
                                                            <IconTruck w="45" h="45" />
                                                            <h4>Lieferzeit</h4>
                                                            {parse(prodACF.prodLineDeliverytime)}
                                                        </div>
                                                        : ''}
                                                    <div className="mb-4">
                                                        <a href="#ausfuehrungen" className="inline-block btn btn-green" title={prod.title}>
                                                            Nähere Infos
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </>
                            )
                        })}
                    </div>
                    {totalProducts > 4 &&
                        <div className="hidden lg:flex justify-end pt-12">
                            <button onClick={() => { scrollDiv('prodCategory', 'left', totalProducts) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                    <g id="Pfeil" transform="translate(32.621)">
                                        <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H-29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3" />
                                        <path id="Fill_12" data-name="Fill 12" d="M-2.047,24.543,0,22.344-10.838,12.273,0,2.2-2.047,0l-13.2,12.273Z" transform="translate(-17.378)" />
                                    </g>
                                </svg>
                            </button>
                            <button className="ml-2" onClick={() => { scrollDiv('prodCategory', 'right', totalProducts) }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="32.621" height="24.543" viewBox="0 0 32.621 24.543">
                                    <g id="Pfeil" transform="translate(0)">
                                        <path id="Stroke_10" data-name="Stroke 10" d="M0,.5H29.378" transform="translate(0 11.771)" fill="none" stroke="#000" strokeMiterlimit="10" strokeWidth="3" />
                                        <path id="Fill_12" data-name="Fill 12" d="M2.047,24.543,0,22.344,10.838,12.273,0,2.2,2.047,0l13.2,12.273Z" transform="translate(17.378)" />
                                    </g>
                                </svg>
                            </button>
                        </div>
                    }
                </div>
            </section>
            <section className="bg-rekord-lorange mb-12 md:mb-24">
                <div className="advantages container mx-auto py-16 lg:py-24">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-12 md:gap-12 lg:gap-24 text-center">
                        <div className="flex flex-col items-center justify-start">
                            <IconTransparency w="45" h="45" />
                            <h4 className="mt-4">Hohe<br />Durchsicht</h4>
                            <p>mehr Tageslicht</p>
                        </div>
                        <div className="flex flex-col items-center justify-start">
                            <IconPermeability w="45" h="45" />
                            <h4 className="mt-4">Hohe<br />Luftdurchlässigkeit</h4>
                            <p>mehr Frischluft, weniger Feinstaub</p>
                        </div>
                        {acf.prodCategoryBestPrice && acf.prodCategoryBestPrice !== '' ?
                            <Link to="/unsere-best-preis-garantie" className="flex flex-col items-center justify-start text-black no-underline">
                                <IconPriceWarranty w="45" h="45" />
                                <h4 className="mt-4">Bestpreis-Garantie</h4>
                                <p>Bei uns bekommst du immer den<br />besten Preis auf alle Produkte</p>
                            </Link>
                            :
                            <div className="flex flex-col items-center justify-start">
                                <IconPriceWarranty w="45" h="45" />
                                <h4 className="mt-4">Bestpreis-Garantie</h4>
                                <p>Bei uns bekommst du immer den<br />besten Preis auf alle Produkte</p>
                            </div>
                        }
                    </div>
                </div>
            </section>
            {acf.prodCategoryTextLeft && acf.prodCategoryTextRight ?
                <section className="container mx-auto pb-6 md:pb-12 lg:pb-24 grid grid-cols-1 lg:grid-cols-2 lg:gap-x-24">
                    <div className="lg:pl-48">{parse(acf.prodCategoryTextLeft)}</div>
                    <div className="lg:pr-48">
                        {acf.prodCategoryBestPrice && acf.prodCategoryBestPrice !== '' ? <div className="best-price-warranty" id="best-preis-garantie">{parse(acf.prodCategoryBestPrice)}</div> : ''}
                        {parse(acf.prodCategoryTextRight)}
                    </div>
                </section>
                : ''}
            {acf.pollenschutzStyles ?
                <section className="container mx-auto pt-12 lg:pt-24 product-opening-types" id="ausfuehrungen">
                    <div className="max-w-5xl mx-auto">
                        <h3 className="text-center mb-12">Ausführungen</h3>
                        <Swiper
                            className="opening-types-slider"
                            navigation
                            pagination={{ clickable: true }}
                            modules={[Navigation]}
                            spaceBetween={0}
                            slidesPerView={1}
                        >
                            {acf.pollenschutzStyles.map((style, index, row) => {

                                const img = style.image

                                return (
                                    <SwiperSlide key={'slide_opening_' + index}>
                                        <div className="mx-12 lg:mx-24 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-center">
                                            <img className="md:order-2 w-full aspect-square object-cover" src={img.sourceUrl} alt={img.altText} sizes="(max-width: 500px) 100vw, 500px" />
                                            <div className="md:order-1 p-0 md:p-6 text-sm md:text-base">{parse(style.description)}</div>
                                        </div>
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </div>
                </section>
                : ''}
            <section className="container mx-auto py-12 lg:py-24">
                <h3 className="text-center mb-12">Gewebeart</h3>
                <div className="lg:mx-24 grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 items-center">
                    <img className="order-1 md:order-2 w-full m-0" src={acf.pollenschutzNetTypeImg.sourceUrl} alt={acf.pollenschutzNetTypeImg.altText} sizes="(max-width: 500px) 100vw, 500px" />
                    <div className="order-2 md:order-1 p-0 md:p-6 text-sm">{parse(acf.pollenschutzNetTypeText)}</div>
                </div>
            </section>
            <PriceCalculatorBanner />
            {acf.pollenschutzCategoryFaq ?
                <section className="bg-rekord-lorange my-4">
                    <div className="max-w-6xl mx-auto lg:px-24 py-24 lg:py-36">
                        <h2 className="text-3xl lg:text-4xl mb-12 px-4">Häufig gestellte Fragen</h2>
                        <BlockFAQ faqs={acf.pollenschutzCategoryFaq} />
                    </div>
                </section>
                : ''}
            <BlockAdvantages />
            {/*
            <section className="relative w-full h-60-screen hero mt-4">
                <div className="absolute w-full left-0 bottom-12 z-10">
                    <div className="container mx-auto">
                        <span className="block text-2xl lg:text-4xl text-black font-bold mb-12">
                            Die regionale Produktion<br/>
                            unsere Fenstersprossen<br/>
                            <b className="text-rekord-lgreen">greifbar nahe</b>
                        </span>
                        <Link className="btn btn-lgreen" to="/">zur Produktionsführung</Link>
                    </div>
                </div>
                <div className="w-full h-full">
                  <img className="w-full h-full object-cover" srcSet={acf.prodCategoryCover.srcSet} alt={title} sizes="(max-width: 2560px) 100vw, 2560px" />
                </div>
            </section>
            */}
            <BlockAdvices />
            <BlockLastProjects />
        </Layout>
    )
}

export const query = graphql`
   query($slug: String!) {
      wpPage(slug: {eq: $slug}) {
         title
         slug
         uri
        seoMetaData {
            seoMetaTitle
            seoMetaDescription
            seoMetaOgImage {
            height
            width
            sourceUrl
            mimeType
            }
        }
          pollenschutzArchACF {
            prodCategoryCover {
              srcSet
            }
            pollenschutzCategoryFaq {
              question
              answer
            }
            pollenschutzStyles {
               description
               image {
                  altText
                  sourceUrl
               }
            }
            pollenschutzNetTypeText
            pollenschutzNetTypeImg {
               altText
               sourceUrl
            }
            prodCategoryHerotitle
            prodCategoryListSubtitle
            prodCategoryListTitle
            prodCategoryTextLeft
            prodCategoryBestPrice
            prodCategoryTextRight
            pollenschutzGroups {
              groupProducts {
                ... on WpPollenschutz {
                  slug
                  title
                  pollenschutzACF {
                    prodLineShortDescription
                    prodLineImage {
                      altText
                      srcSet
                    }
                    prodLinePricecat
                    prodLinePollen
                    prodLineDeliverytime
                  }
                }
              }
              groupTitle
            }
          }
        }
   }
`
